import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductoActividad } from '../../../_models/producto-actividad';
import { Producto } from '../../../_models/producto';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ProductoActividadService } from '../../../_services/producto-actividad.service';
import { ProductoActividadCampoService } from '../../../_services/producto-actividad-campo.service';
import { FuncionalidadesService } from '../../../_services/funcionalidades.service';
import { ProductoActividadCampo } from '../../../_models/producto-actividad-campo';
import { SegmentosService } from '../../../_services/segmentos.service';
import { Segmento } from '../../../_models/segmento';
import { forkJoin } from 'rxjs';
import { UntypedFormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../../_models/funcionalidad-control';

@Component( {
  selector: 'app-producto-actividad-aliado-editar',
  templateUrl: 'producto-actividad-aliado-editar.component.html'
} )

export class ProductoActividadAliadoEditarComponent implements OnInit {

  @Input() proActividad: ProductoActividad;
  @Input() producto: Producto;
  @Input() lisProductoActividad: ProductoActividad[] = [];
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
  @Output() listado: EventEmitter<ProductoActividad[]> = new EventEmitter();
  lisProductoActividadCampo: ProductoActividadCampo[] = [];
  carInformacionInicial = true;
  lisTodosSegmentos: Segmento[] = [];
  lisSegmentos: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  lisTodosFuncionalidadesControles: FuncionalidadControl[] = [];
  iterador: number[] = [];


  constructor( private navServicio: NavService,
               private proActividadServicio: ProductoActividadService,
               private proActividadCampoServicio: ProductoActividadCampoService,
               private segServicio: SegmentosService,
               private funServicio: FuncionalidadesService,
               private fb: FormBuilder,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.iterador.push( 0 );
    this.iterador.push( 1 );
    this.iterador.push( 2 );
    if ( this.proActividad ) {
      this.proActividadCampoServicio.listadoPorProductoActividad( this.proActividad.idProductoSegmento ).subscribe( lisActividadCampo => {
        this.lisProductoActividadCampo = lisActividadCampo;
        this.cargarServiciosIniciales();
      } );
    } else {
      this.cargarServiciosIniciales();
    }
  }

  cargarServiciosIniciales() {
    forkJoin( this.segServicio.listado(), this.funServicio.obtenerFuncionalidadesControlesPorCodigoFuncionalidad( 'DINSOL' ) ).subscribe( ( [ lisSegmentos, lisFuncionalidades ] ) => {
      this.lisTodosSegmentos = lisSegmentos;
      const a = lisFuncionalidades.find( x => x.codigo === 'SECACTIVIDADES' );
      if ( a ) {
        this.lisTodosFuncionalidadesControles = lisFuncionalidades.filter( x => x.idPadre === a.idFuncionalidadControl );
      }
      this.cargarListadoSegmentos();
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
  }

  cargarListadoSegmentos() {
    this.lisSegmentos = [];
    this.lisTodosSegmentos.map( ( s: Segmento ) => {
      if ( !this.lisProductoActividad.find( x => x.idSegmento === s.idSegmento ) ) {
        this.lisSegmentos.push( { label: s.nombre, value: s.idSegmento } );
      }
    } );
  }


  cargarFormulario() {
    const arrFormularios = [];
    this.lisTodosFuncionalidadesControles.map( ( s: FuncionalidadControl ) => {
      const a = this.lisProductoActividadCampo.find( x => x.idFuncionalidadControl === s.idFuncionalidadControl );
      const formulario = this.fb.group( {
        idProductoSegmentoFuncionalidadControl: [ a ? a.idProductoSegmentoFuncionalidadControl : null ],
        idProductoSegmento: [ a ? a.idProductoSegmento : (this.proActividad ? this.proActividad.idProductoSegmento : null) ],
        idFuncionalidadControl: [ a ? a.idFuncionalidadControl : s.idFuncionalidadControl ],
        indicadorHabilitado: [ a ? a.indicadorHabilitado : (s.codigo === 'ACTECO' ? true : false) ],
        auditoriaFecha: [ a ? a.auditoriaFecha : null ],
        auditoriaUsuario: [ a ? a.auditoriaUsuario : null ],
        nombreCampo: [ a ? a.nombreCampo : s.nombre ],
      } );
      if ( s.codigo === 'ACTECO' ) {
        formulario.controls.indicadorHabilitado.disable();
      }
      arrFormularios.push( formulario );
    } );


    this.formulario = this.fb.group( {
      idProductoActividad: [ this.proActividad ? this.proActividad.idProductoSegmento : null ],
      idProducto: [ this.proActividad ? this.proActividad.idProducto : this.producto.idProducto, [ Validators.required ] ],
      idSegmento: [ this.proActividad ? this.proActividad.idSegmento : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.proActividad ? this.proActividad.indicadorHabilitado : true ],
      nombreSegmento: [ this.proActividad ? this.proActividad.nombreSegmento : null ],
      campos: this.fb.array( arrFormularios )
    } );
  }


  get f() {
    return this.formulario.controls;
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'actividad-editar',
        accept: () => {
          this.dismiss.emit( false );
        },
        reject: () => {
        }
      } );
    } else {
      this.dismiss.emit( false );
    }
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_GUARDARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'actividad-editar',
        accept: () => {
          this.guardando = true;
          if ( this.proActividad ) {
            const campos = this.campos ? this.campos.getRawValue() : [];
            const solHabilitados = campos.filter(x => x.idProductoSegmentoFuncionalidadControl || (!x.idProductoSegmentoFuncionalidadControl && x.indicadorHabilitado));
            if ( solHabilitados.length > 0 ) {
              this.proActividadCampoServicio.bulk( solHabilitados ).subscribe( camActualizado => {
                this.navServicio.setMesage( 2 );
                this.guardando = false;
                this.dismiss.emit( false );
              } );
            } else {
              this.navServicio.setMesage( 2 );
              this.guardando = false;
              this.dismiss.emit( false );
            }
          } else {
            const forSegmentos = this.formulario.value;
            this.proActividadServicio.crear( forSegmentos ).subscribe( segCreado => {
              const nueRegistro = {} as ProductoActividad;
              nueRegistro.idProductoSegmento = segCreado.idProductoSegmento;
              nueRegistro.idProducto = segCreado.idProducto;
              nueRegistro.idSegmento = segCreado.idSegmento;
              nueRegistro.indicadorHabilitado = segCreado.indicadorHabilitado;
              nueRegistro.auditoriaFecha = segCreado.auditoriaFecha;
              nueRegistro.auditoriaUsuario = segCreado.auditoriaUsuario;
              const a = this.lisTodosSegmentos.find( x => x.idSegmento === forSegmentos.idSegmento );
              if ( a ) {
                nueRegistro.nombreSegmento = a.nombre;
              }
              this.lisProductoActividad.push(nueRegistro);
              const campos = this.campos ? this.campos.getRawValue() : [];
              const solHabilitados = [];
              campos.map((s: ProductoActividadCampo) => {
                  if(s.indicadorHabilitado){
                    s.idProductoSegmento = segCreado.idProductoSegmento;
                    solHabilitados.push(s);
                  }
              });
              if ( solHabilitados.length > 0 ) {
                this.proActividadCampoServicio.bulk( solHabilitados ).subscribe( camActualizado => {
                  this.navServicio.setMesage( 1 );
                  this.guardando = false;
                  this.listado.emit(this.lisProductoActividad);
                  this.dismiss.emit( false );
                } );
              } else {
                this.navServicio.setMesage( 1 );
                this.guardando = false;
                this.listado.emit(this.lisProductoActividad);
                this.dismiss.emit( false );
              }
            } );
          }
        },
        reject: () => {
        }
      } );
    }
  }

  get campos() {
    return this.formulario.get( 'campos' ) as UntypedFormArray;
  }


}
